import React from 'react'
import { ChipVariant } from './ChipVariant.type'

export type ChipGroupProps = {
  children: React.ReactNode
  groupType: ChipVariant | string
  role?: 'radiogroup' | 'group'
  ariaLabel?: string
  className?: string
  testId?: string
}

export const ChipGroup = ({
  children,
  groupType,
  role,
  ariaLabel,
  className,
  testId
}: ChipGroupProps): JSX.Element => {
  const classNames = ['Chip-group']
  if (className) classNames.push(className)

  return (
    <div
      className={classNames.join(' ')}
      data-chip-group={groupType}
      role={role || undefined}
      aria-label={ariaLabel || undefined}
      data-testid={testId || null}
    >
      {children}
    </div>
  )
}
